import { FC } from 'react';
import { faCircleUser } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { CampaignDetail } from '@/apis/core/types';

interface CspDetailsSectionProps {
  campaign?: CampaignDetail;
}

const CspDetailsSection: FC<CspDetailsSectionProps> = ({ campaign }) => {
  return (
    <RcsSectionBlock icon={faCircleUser} title="CSP Details" showDivider={true}>
      <InfoItemLayout.Vertical>
        <InfoItemLayout.Horizontal>
          <InfoItem title="CSP Legal Name">
            {campaign?.brand?.csp.companyName}
          </InfoItem>
          <InfoItem title="CSP DBA Name">
            {campaign?.brand?.csp.displayName}
          </InfoItem>
        </InfoItemLayout.Horizontal>
      </InfoItemLayout.Vertical>
    </RcsSectionBlock>
  );
};

export default CspDetailsSection;
